import React from 'react';
import { cardSurfaceClass, cx } from '../theme';

export default function PageFooter({ lines }) {
  return (
    <footer className={cx(cardSurfaceClass, 'mt-8 px-6 py-6 text-center text-[11px] leading-relaxed text-slate-500')}>
      {lines.map((line) => (
        <div key={line} data-coo="footer-line">
          {line}
        </div>
      ))}
    </footer>
  );
}
